import { scoreBg, scoreColor } from '@workspace/seedforge-shared'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@workspace/ui/components/collapsible'
import { cn } from '@workspace/ui/lib/utils'
import { ChevronRight } from 'lucide-react'
import { useState } from 'react'
import { Prose } from '../../components/prose'

export interface MetricBarProps {
  label: string
  score: number
  /** When provided, renders the bar as expandable with reasoning text */
  reasoning?: string
}

export function MetricBar({ label, score, reasoning }: MetricBarProps) {
  const [open, setOpen] = useState(false)

  const bar = (
    <>
      <span className="w-32 shrink-0 text-right text-xs text-muted-foreground">{label}</span>
      <div className="relative h-2 flex-1 rounded-full bg-input">
        <div className={cn('h-2 rounded-full', scoreBg(score))} style={{ width: `${score}%` }} />
      </div>
      <span className={cn('w-8 text-right text-sm font-semibold', scoreColor(score))}>{score}</span>
    </>
  )

  if (!reasoning) {
    return <div className="flex items-center gap-4 px-2 py-1.5">{bar}</div>
  }

  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger className="group flex w-full items-center gap-4 rounded-lg px-2 py-1.5 transition-colors hover:bg-white/[0.02]">
        {bar}
        <ChevronRight
          className={cn(
            'size-3.5 shrink-0 text-muted-foreground/80 transition-transform',
            open && 'rotate-90'
          )}
        />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="pb-2 pl-36 pr-16">
          <Prose className="text-xs leading-relaxed text-muted-foreground">{reasoning}</Prose>
        </div>
      </CollapsibleContent>
    </Collapsible>
  )
}
